import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useResourceCount } from '../../../hooks/useResourceCount'

import Icon from '../../../components/ui/Icon'
import { Button } from '../../../components/buttons/Button'
import PageHeader from '../../../components/ui/pageHeader/PageHeader'
import { CourtList } from '../../../components/authenticated/management/court/CourtList'

export const Courts = () => {
  const navigate = useNavigate()
  const { clubId } = useParams()
  const { t } = useTranslation('courts')
  const { count: courtsNumber } = useResourceCount(
    '/api/v1/courts/count',
    { clubId }
  )

  const goTo = (path: string) => {
    navigate(path)
  }

  return (
    <>
      <PageHeader
        title={{
          eyebrow:
            courtsNumber === null
              ? undefined
              : t('courts.page-header.eyebrow', {
                  courtsNumber,
                }),
          h1: t('courts.page-header.title'),
        }}
        sub={t('courts.page-header.subtitle')}
        actions={[
          <Button
            key="new-court"
            label={t('courts.page-header.new-btn')}
            icon={<Icon name="plus" size={14} />}
            size="md"
            onClick={() => goTo('/m/courts/new')}
          />,
        ]}
      />
      <CourtList clubId={clubId} />
    </>
  )
}
